import { PersonHttpHelper, NO_DATA_MESSAGE } from '../../utils/HttpHelper';

const GetFlatPersonByMemberIdData = (memberId, state, setState) => {
  if (state.isObjLoading !== true) {
    const newState = {
      ...state,
      isObjLoading: true,
      isObjLoaded: false,
    };
    setState(newState);

    const memberIdForUrl = memberId ? encodeURIComponent(memberId) : 'NaN';
    const url = `/Person/flat/memberId/${memberIdForUrl}`;
    PersonHttpHelper(url, 'GET')
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isObjLoading: false,
            isObjLoaded: true,
            objData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...state,
          message: message
        });
      });
  }
};

export default GetFlatPersonByMemberIdData;